export default __webpack_public_path__ + "static/media/diamond-green-dots.fd973992.svg";